// Utility function to parse a boolean string ie. in a querystring
export const parseBool = (value: string | boolean): boolean => {
  if (typeof value === 'boolean') {
    return value
  }
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true'
  }

  return false
}
